import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Button, Table } from 'semantic-ui-react'
import Filters from './filters'
import DisplayExchangeRate from './displayExchangeRate'
import { useGetExchangeRatesData } from './useGetExchangeRatesData'
import { CustomLoader } from '../formComponents/loader'

const List = React.memo(({ renderItem,dataSource=[]}) =>dataSource.map(renderItem))

 const DisplayExchangeRatesList =({displayRateRenewBtn,displayRenewWarning,DropDownReducer = 'DropDownValues'})=>{
    const currencyList = useSelector((state) => state[DropDownReducer]?.currencyCodes)
    const {copySelectedRow,saveExchangeRate,onChange,data,setFilterData,filterData,deleteRow,updateCustomRates,isLoading}=useGetExchangeRatesData()

    const renderItem=useCallback((params)=><DisplayExchangeRate key={params.id} deleteRow={deleteRow} onChange={onChange} copySelectedRow={copySelectedRow} saveExchangeRate={saveExchangeRate} currencyList={currencyList} {...params} />,[currencyList,onChange,saveExchangeRate,copySelectedRow])
    return(
      <>
      <div className='exchangeRateWarning toast'></div>
      <Filters data={filterData} onFiltersChange={setFilterData} />
      {isLoading && <CustomLoader></CustomLoader> }
       <div className='container__table'>
        <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>FROM CURRENCY</Table.HeaderCell>
            <Table.HeaderCell>TO CURRENCY</Table.HeaderCell>
            <Table.HeaderCell>FROM DATE</Table.HeaderCell>
            <Table.HeaderCell>TO DATE</Table.HeaderCell>
             <Table.HeaderCell >EXCHANGE RATES</Table.HeaderCell>
             <Table.HeaderCell ></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
    
        <Table.Body>
        {
             <Table.Row>
            <Table.Cell>
  
            </Table.Cell>
              <Table.Cell  colSpan={5} textAlign='right'>
            {displayRenewWarning()}
            <Button disabled={!displayRateRenewBtn} onClick={updateCustomRates} size="mini" className='sv todo-button'>REQUEST CUSTOM RATES</Button>
            </Table.Cell>
          </Table.Row>
        }
          <List dataSource={data} renderItem={renderItem} ></List>
        </Table.Body>

      </Table>
      
      </div>
      </>
    )
}

const MemoizeDisplayExchangeRatesList=React.memo(DisplayExchangeRatesList)
export {MemoizeDisplayExchangeRatesList}